
function Footer() {
    return (
        <div className="footer">
            <div className="sec-footer">
                <div className="container">
                    <p className="title">Menu</p>
                    <div className="content">
                        <div className="item">
                            <a className="w-max" href={`${process.env.REACT_APP_LINK_URL}/company`}>Giới thiệu</a>
                            <a className="w-max" href={`${process.env.REACT_APP_LINK_URL}/terms`}>Điều khoản sử dụng</a>
                        </div>
                        <div className="item">
                            <a className="w-max" href={`${process.env.REACT_APP_LINK_URL}/privacy-policy`}>Chính sách bảo mật</a>
                            <a className="w-max" href={`${process.env.REACT_APP_LINK_URL}/harassment-policy`}>Chính sách chống quấy rối</a>
                        </div>
                        <div className="item">
                            <a className="w-max" href={`${process.env.REACT_APP_LINK_URL}/content-policy`}>Chính sách nội dung</a>
                            <a className="w-max" href={`${process.env.REACT_APP_LINK_URL}/sitemap`}>Sơ đồ trang web</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <a href={`${process.env.REACT_APP_LINK_URL}`} className="logo">
                    {/* <img src="" alt="" /> */}
                        <p>
                            PRI.VN
                        </p>
                </a>
                <p className="content">© copyright</p>
            </div>
        </div>
    );
}

export default Footer;